import utils from '@/common/util/utils'
export default class VodPlayer {
  static EVENT = {
    ON_ERROR: 'onError',
    ON_FULLSCREEN_ENTER: 'onFullScreenEnter',
    ON_FULLSCREEN_EXIT: 'onFullScreenExit',
    ON_READY: 'onReady',
    ON_PAUSED: 'onPaused',
    ON_PLAY: 'onPlay',
    ON_PLAYBACK_FINISHED: 'onPlayBackFinished',
    ON_PLAYER_RESIZE: 'onPlayerResize',
    ON_SOURCE_LOADED: 'onSourceLoaded',
    ON_STALL_STARTED: 'onStallStarted',
    ON_STALL_ENDED: 'onStallEnded',
    ON_TIME_CHANGED: 'onTimeChanged',
    ON_TIME_SHIFT: 'onTimeShift',
    ON_TIME_SHIFTED: 'onTimeShifted',
    ON_VOLUME_CHANGED: 'onVolumeChanged'
  }
  constructor (id) {
    let key = id.replace(/_/gi, '')
    this.id = key
    this.isInit = false
    this.player = null
    this.parent = null
    this.screen = null
    this.fullscreen = false
    this.duration = 0
    this.volume = 0
    this.playing = false
    this.seekingAble = false
    this.isPlayStatus = false
    this.isError = false
  }
  addPlayer (div, bufferTime, volume, source) {
    this.volume = volume
    this.parent = div
    this.screen = document.createElement('div')
    this.screen.style.position = 'absolute'
    this.screen.style.top = '0px'
    this.screen.style.width = '100%'
    this.screen.style.height = '100%'
    this.parent.appendChild(this.screen)
    this.player = document.createElement('video')
    this.player.id = 'vplayer'
    this.player.style.position = "absolute";
    this.player.style.zIndex = 0;
    this.player.preload = 'auto'
    this.player.setAttribute('autoplay', 'autoplay')
    // this.player.setAttribute('controls', 'controls')
    this.screen.appendChild(this.player)
    this.player.width = '100%'
    this.player.height = '100%'
    this.player.addEventListener('loadstart', this.onLoadStart.bind(this), false)
    this.player.addEventListener('timeupdate', this.onTimeUpdate.bind(this), false)
    this.player.addEventListener('seeking', this.onSeek.bind(this), false)
    this.player.addEventListener('seeked', this.onSeeked.bind(this), false)
    this.player.addEventListener('pause', this.onPause.bind(this), false)
    this.player.addEventListener('playing', this.onPlaying.bind(this), false)
    this.player.addEventListener('loadeddata', this.onLoadedData.bind(this), false)
    this.player.addEventListener('waiting', this.onLoadStart.bind(this), false)
    this.player.addEventListener('suspend', this.onLoaded.bind(this), false)
    this.player.addEventListener('stalled', this.onLoaded.bind(this), false)
    this.player.addEventListener('ended', this.onCompleted.bind(this), false)
    this.player.addEventListener('progress', this.onProgress.bind(this), false)
    this.player.addEventListener('error', this.onPlayerError.bind(this), false)
    // this.player.addEventListener('canplay', this.onLoaded.bind(this), false)
    // console.log('FALL_BACK_HTML_VS : 1.0.0')
    this.load(source)
    this.setVolume(volume)
    this.sizeUpdate()
  }
  onLoadStart (e) {
    if (this.isInit === false) {
      this.isInit = true
      this.isPlayStatus = true
    }

    // jarvis.debuger.log('onLoadStart')
    this.seekingAble = true
    this.dispatchEvent(VodPlayer.EVENT.ON_READY)
    this.dispatchEvent(VodPlayer.EVENT.ON_STALL_STARTED)
  }
  onLoaded () {
    // jarvis.debuger.log('onLoaded')
    this.seekingAble = true
    this.dispatchEvent(VodPlayer.EVENT.ON_STALL_ENDED)
  }
  onLoadedData () {
    this.dispatchEvent(VodPlayer.EVENT.ON_SOURCE_LOADED)
  }
  onTimeUpdate () {
    this.dispatchEvent(VodPlayer.EVENT.ON_TIME_CHANGED)
  }
  onSeek () {
    this.seekingAble = false
    this.dispatchEvent(VodPlayer.EVENT.ON_TIME_SHIFT)
  }
  onSeeked () {
    this.seekingAble = true
    this.dispatchEvent(VodPlayer.EVENT.ON_TIME_SHIFTED)
  }
  onPause () {
    this.playing = false
    this.dispatchEvent(VodPlayer.EVENT.ON_PAUSED)
  }
  onPlaying () {
    if (this.seekingAble === false) {
      this.onLoaded()
    }
    this.dispatchEvent(VodPlayer.EVENT.ON_TIME_CHANGED)
    this.playing = true
    this.dispatchEvent(VodPlayer.EVENT.ON_PLAY)
  }
  onCompleted () {
    this.dispatchEvent(VodPlayer.EVENT.ON_PLAYBACK_FINISHED)
  }
  onProgress () {
    if (this.player.buffered) {
      if (this.player.duration !== 0) {
        try {
          let progress = this.player.buffered.end(0) / this.player.duration
          // console.log('pct : '+progress)
        } catch (e) {

        }
      }
    }
  }
  onPlayerError (e) {
    // console.log('onPlayerError : ' + this.isPlayStatus)
    console.log(e)
    if (this.isPlayStatus === false) {
      return
    }
    //  jarvis.debuger.log(JSON.stringify(e))
    this.isError = true
    this.dispatchEvent(VodPlayer.EVENT.ON_ERROR, e)
  }
  unload () {
    this.stop()
  }
  sizeUpdate () {
    if (this.player != null) {
      let size = utils.getAbsoluteBounce(this.screen)
      this.player.width = size.width
      this.player.height = size.height
    }
    this.dispatchEvent(VodPlayer.EVENT.ON_PLAYER_RESIZE)
    let fullscreen = ((typeof document.webkitIsFullScreen) !== 'undefined') ? document.webkitIsFullScreen : document.mozFullScreen
    if (this.fullscreen !== fullscreen) {
      this.fullscreen = fullscreen
      if (this.fullscreen === true) {
        this.dispatchEvent(VodPlayer.EVENT.ON_FULLSCREEN_ENTER)
      } else {
        this.dispatchEvent(VodPlayer.EVENT.ON_FULLSCREEN_EXIT)
      }
    }
  }
  load (vodObject) {
    if (this.player == null) {
      return
    }
    this.isError = false
    this.playing = false
    this.seekingAble = false
    this.duration = 0
    this.player.src = vodObject.getVodUrl()
  }
  getAvailableVideoQualities () {
    return []
  }
  pause () {
    if (this.player == null) {
      return
    }
    this.player.pause()
  }
  stop () {
    if (this.player == null) {
      return
    }
    this.isPlayStatus = false
    this.player.pause()
    try {
      this.player.unload()
    } catch (e) {

    }
  }
  play () {
    if (this.player == null) {
      return
    }
    this.player.play()
  }
  seek (pos) {
    if (this.seekingAble === false) {
      return false
    }
    this.player.currentTime = pos
    // console.log('this.player.currentTime', this.player.currentTime)
    return true
  }
  isPlaying () {
    return this.playing
  }
  isPaused () {
    if (this.playing === false) {
      return true
    } else {
      return false
    }
  }
  getVolume () {
    if (this.player == null) {
      return 0
    }
    return this.volume
  }
  setVolume (v) {
    this.volume = v
    if (this.player != null) {
      this.player.volume = Number(this.volume) / 100
    }
    this.dispatchEvent(VodPlayer.EVENT.ON_VOLUME_CHANGED)
  }
  getPlayerType () {
    return 'video'
  }
  getCurrentTime () {
    return this.player.currentTime
  }
  getDuration () {
    return this.duration
  }
  isFullscreen () {
    return this.fullscreen
  }
  enterFullscreen () {
    if (this.parent.requestFullscreen) {
      this.parent.requestFullscreen()
    } else if (this.parent.mozRequestFullScreen) {
      this.parent.mozRequestFullScreen()
    } else if (this.parent.webkitRequestFullscreen) {
      this.parent.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
    }
  }
  exitFullscreen () {
    if (document.cancelFullScreen) {
      document.cancelFullScreen()
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen()
    }
  }
  getThumb (t) {
    return null
  }
  getPlaybackSpeed () {
    return 1
  }
  setPlaybackSpeed (spd) {}
  dispatchEvent (event, data) {
    if (this.player == null) {
      return
    }
    if (document.createEventObject) {
      // console.log('1', event)
      let evt = document.createEventObject()
      evt.data = data
      return this.screen.fireEvent(event, evt)
    } else {
      let evt = document.createEvent('HTMLEvents')
      evt.initEvent(event, true, true)
      evt.data = data
      return !this.screen.dispatchEvent(evt)
    }
  }
  addEventHandler (event, fn, useCapture) {
    if (document.createEventObject) {
      this.screen.attachEvent(event, fn, useCapture)
    } else {
      this.screen.addEventListener(event, fn, useCapture)
    }
  }
  destroy () {
    if (this.player == null) {
      return
    }
    // console.log('destroy!!!!')
    this.stop()
    this.screen.remove()
    // jarvis.lib.removeChild(this.screen)
    this.player = null
    this.screen = null
    this.parent = null
  }
}
